var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.875H15.9375C16.3515 14.8738 16.7482 14.7087 17.041 14.416C17.3337 14.1232 17.4988 13.7265 17.5 13.3125V7.0625C17.4988 6.64848 17.3337 6.25177 17.041 5.95901C16.7482 5.66625 16.3515 5.50124 15.9375 5.5H4.0625C3.64848 5.50124 3.25177 5.66625 2.95901 5.95901C2.66625 6.25177 2.50124 6.64848 2.5 7.0625V13.3125C2.50124 13.7265 2.66625 14.1232 2.95901 14.416C3.25177 14.7087 3.64848 14.8738 4.0625 14.875H5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.05 9.875H5.95C5.42533 9.875 5 10.3003 5 10.825V17.05C5 17.5747 5.42533 18 5.95 18H14.05C14.5747 18 15 17.5747 15 17.05V10.825C15 10.3003 14.5747 9.875 14.05 9.875Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5V4.5625C14.9988 4.14848 14.8337 3.75177 14.541 3.45901C14.2482 3.16625 13.8515 3.00124 13.4375 3H6.5625C6.14848 3.00124 5.75177 3.16625 5.45901 3.45901C5.16625 3.75177 5.00124 4.14848 5 4.5625V5.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 8.625C15.8303 8.625 16.25 8.20527 16.25 7.6875C16.25 7.16973 15.8303 6.75 15.3125 6.75C14.7947 6.75 14.375 7.16973 14.375 7.6875C14.375 8.20527 14.7947 8.625 15.3125 8.625Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.ce25776a5c31ff9e99fafcdfe8ea9e64.svg";
export { ForwardRef as ReactComponent };